import { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Spinner } from '../../shared/components';
import BasePage from '../../shared/components/layout/BasePage/BasePage';
import { routes } from './route-config';
import useAuthContext from '../providers/AuthProvider';
import { usePermission } from '../../shared/hooks/usePermission';
import { permissionService, Permissions } from '../../shared/services/permission.service';
import { Role } from '../../features/auth/models';

const waitFor = (Tag: React.LazyExoticComponent<() => JSX.Element | null>) => (
  <Suspense fallback={<Spinner />}>
    <Tag />
  </Suspense>
);

export default function AppRouter() {
  const { idToken } = useAuthContext();
  const { hasAnyPermission } = usePermission();

  const publicRoutes = routes
    .filter((route) => !route.auth || route.isPublic)
    .map((route) => <Route key={route.path} path={route.path} element={waitFor(route.component)} />);

  if (!idToken) return <Routes>{publicRoutes}</Routes>;

  const authenticatedRoutes = routes
    .filter((route) => (route.auth && (!route.permissions || hasAnyPermission(route.permissions))) || route.isPublic)
    .map((route) => <Route key={route.path} path={route.path} element={waitFor(route.component)} />);

  return (
    <BasePage>
      <Routes>{authenticatedRoutes}</Routes>
    </BasePage>
  );
}

export { routes } from './route-config';

const findFirstPermittedRoute = (
  routesList: typeof routes,
  hasAny: (permissions: Permissions[]) => boolean,
) => {
  return routesList.find((route) => route.auth && route.permissions && hasAny(route.permissions));
};

export const getLandingPage = (role?: Role) => {
  const landingPage = findFirstPermittedRoute(routes, (permissions) =>
    permissionService.hasAnyPermission(role || null, permissions),
  );
  return landingPage ?? null;
};


